'use strict';
/**
 *  Load modules
 */

import echo from './modules/echo.js';
import '../scss/app.scss';
import autosize from 'autosize/dist/autosize.min';
$(document).ready(function () {
  $('textarea.wpcf7-textarea').attr('rows', 1);
  autosize($('textarea'));
  $('.menu-burger').click(function () {
    $(this).toggleClass('menu-burger_opened');
    $('.login-menu__nav').toggleClass('login-menu__nav_opened');
    $('.login-menu__nav-list a').toggleClass('login-menu__nav-link_visible');
  });
  $(document).on("scroll", window, function () {
    if ($(window).scrollTop() > 50) {
      $(".scroll-header").css('top', 0);

      if ($('.menu-burger').hasClass('menu-burger_opened')) {
        $('.menu-burger').removeClass('menu-burger_opened');
      }

      if ($('.login-menu__nav').hasClass('login-menu__nav_opened')) {
        $('.login-menu__nav').removeClass('login-menu__nav_opened');
      }

      if ($('.login-menu__nav-list a').hasClass('login-menu__nav-link_visible')) {
        $('.login-menu__nav-list a').removeClass('login-menu__nav-link_visible');
      }
    } else {
      $(".scroll-header").removeAttr('style');
    }
  });
  $('.header-slider').slick({
    accessibility: true,
    arrows: false,
    dots: true,
    fade: true,
    cssEase: 'linear',
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000
  });
  $('.header-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.slick-current').children('.header-slider__slide-info').animate({
      'right': '20px',
      'opacity': 0
    }, 200, 'linear');
    var next_slide = $('.slick-slide')[nextSlide];
    $(next_slide).children('.header-slider__slide-info').animate({
      'right': '80px',
      'opacity': 1
    }, 200, 'linear');
  });
  $('.header-slider__slide').click(function () {
    $('.header-slider').slick('slickGoTo', parseInt($('.header-slider').slick('slickCurrentSlide')) + 1);
  });
  $(window).on('load resize', function () {
    var withWindow = window.innerWidth;

    if (withWindow < 1200) {
      if ($('.legend-slider__slider').hasClass('slick-initialized')) {
        $('.legend-slider__slider').slick('unslick');
      }
    } else {
      if ($('.legend-slider__slider').hasClass('slick-initialized')) {
        var _slideHeight = $('.legend-slider__slider .slick-current p').height();

        $('.legend-slider__slider .slick-dots').css('top', _slideHeight + 30 + 'px');
        return;
      } else {
        $('.legend-slider__slider').slick({
          accessibility: true,
          arrows: false,
          dots: true,
          fade: true,
          cssEase: 'linear',
          draggable: false
        });
        $('.legend-slider__slider').slick('slickGoTo', $('.legend-slider__list-item_active').index());
      }

      var slideHeight = $('.legend-slider__slider .slick-current p').height();
      $('.legend-slider__slider .slick-dots').css('top', slideHeight + 30 + 'px');
    }
  });
  $('.legend-slider__list-item').eq('0').addClass('legend-slider__list-item_active');
  $('.legend-slider__list-item').click(function () {
    $('.legend-slider__list-item').removeClass('legend-slider__list-item_active');
    $(this).addClass('legend-slider__list-item_active');
    $('.legend-slider__slider').slick('slickGoTo', $(this).index());
  });
  $('.legend-slider__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    $('.legend-slider__list-item').removeClass('legend-slider__list-item_active');
    $('.legend-slider__list-item').eq(nextSlide).addClass('legend-slider__list-item_active');
    var nextHeight = $('.legend-slider__slide').eq(nextSlide).children('p').eq(0).height();
    $('.legend-slider__slider .slick-dots').animate({
      'top': nextHeight + 30 + 'px'
    }, 300);
  });
  $('.slider-text-accordion__item').click(function () {
    $('.slider-text-accordion__item').not($(this)).children('p').slideUp(1000);
    $('.slider-text-accordion__item').not($(this)).children('div').slideUp(1000);
    $('.slider-text-accordion__item').not($(this)).removeClass('slider-text-accordion__item_active');
    $(this).children('p').slideToggle(1000);
    $(this).children('div').slideToggle(1000);
    $(this).toggleClass('slider-text-accordion__item_active'); //$('.slider-text-accordion__item').not($(this)).removeClass('slider-text-accordion__item_active');
    //$(this).toggleClass('slider-text-accordion__item_active');

    /*if ($(window).width() > 992 && ($(this).hasClass('slider-text-accordion__item_black') == false)){
        if ( ! ($(this).hasClass('slider-text-accordion__item_active')) ){
            $('.slider-text-accordion__accordion').not($('.slider-text-accordion__accordion_black')).css({
                'padding-bottom': '587px'
            });
            return;
        }else {
            /!*$('.slider-text-accordion__accordion').not($('.slider-text-accordion__accordion_black')).css({
                'padding-bottom': 'calc(587px - '+slideHeight+'px)'
            });*!/
        }
    }*/
  });
  $('.team__slider').slick({
    accessibility: true,
    arrows: true,
    dots: false,
    fade: true,
    cssEase: 'linear',
    prevArrow: $('.team__slider_prev'),
    nextArrow: $('.team__slider_next')
  });
  $('.person-switcher__images').slick({
    accessibility: false,
    arrows: false,
    dots: false,
    fade: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable: false,
    swipe: false,
    responsive: [{
      breakpoint: 992,
      settings: 'slick'
    }, {
      breakpoint: 280,
      settings: 'unslick'
    }]
  });
  $('.person-switcher__title').eq('0').addClass('person-switcher__title_active');
  $('.person-switcher__title').click(function (e) {
    $('.person-switcher__title').not($(this)).removeClass('person-switcher__title_active'); //$(this).toggleClass('person-switcher__title_active');

    if ($(this).hasClass('person-switcher__title_active')) {
      e.preventDefault();
      return;
    } else {
      $(this).addClass('person-switcher__title_active');
      $('.person-switcher__images').slick('slickGoTo', parseInt($('.person-switcher__images').slick('slickCurrentSlide')) + 1);
      $('.person-switcher__descriptions').slick('slickGoTo', parseInt($('.person-switcher__descriptions').slick('slickCurrentSlide')) + 1);
    }
  });
  $('.person-switcher__descriptions').slick({
    accessibility: false,
    arrows: false,
    dots: false,
    fade: true,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable: false,
    swipe: false
  });
  $('.main-form__column input, .main-form__column textarea').on('focus', function () {
    var fontSize = '18px';

    if ($(window).width() < 768) {
      fontSize = '10px';
    }

    $(this).parent('span').siblings('span.custom-placeholder').css('display', 'block');
    $(this).parent('span').siblings('span.custom-placeholder').animate({
      'top': '-16px',
      'font-size': fontSize,
      'color': '#BCBAB5',
      'opacity': 1
    }, 200);
  });
  $('.main-form__column input, .main-form__column textarea').on('blur', function () {
    $(this).parent('span').siblings('span.custom-placeholder').css('display', 'none');
    $(this).parent('span').siblings('span.custom-placeholder').animate({
      'top': '16px',
      'font-size': '28px',
      'color': '#BCBAB5',
      'opacity': 0
    }, 200);
  });
  $('#agreement_check>.wpcf7-list-item>label').click(function () {
    if ($('#agreement_check input[type="checkbox"]').prop('checked')) {
      $('#agreement_check>.wpcf7-list-item>label').addClass('checked');
    } else {
      $(this).removeClass('checked');
    }
  });

  if ($(window).width() < 993) {
    $('.person-switcher__images').css('display', 'none');
  }

  $(window).resize(function () {
    if ($(window).width() < 993) {
      $('.person-switcher__images').css('display', 'none');
    } else {
      $('.person-switcher__images').removeAttr('style');
    }
  });
  $('.header__mobile-menu').click(function () {
    $(this).toggleClass('header__mobile-menu_active');
  });
  document.addEventListener('wpcf7mailsent', function (event) {
    $('.main-form__submit').attr('value', 'gesendet');
    $('.main-form__submit').css('color', 'white');
    $('.main-form__success-sign').css({
      'display': 'block'
    });
    $('.main-form__submit-label').css('background-color', 'black');
    $('.wpcf7-response-output').css('display', 'none');
    $('.main-form__submit-arrow').css('display', 'none');
    $('.main-form__submit-label').addClass('main-form__submit-label_success');
    setTimeout(function () {
      $('.main-form__submit').attr('value', 'senden');
      $('.main-form__submit').removeAttr('style');
      $('.main-form__success-sign').css('display', 'none');
      $('.main-form__submit-arrow').removeAttr('style');
      $('.main-form__submit-label').removeAttr('style');
      $('.main-form__submit-label').removeClass('main-form__submit-label_success');
    }, 2000);
  }, false);

  if ($('.main-form__submit').attr('value') == 'gesendet') {
    $('.main-form__submit').click(function (e) {
      e.preventDefault();
    });
  }

  var scroll = new SmoothScroll('a[href*="#"]', {
    speed: 800
  });
  jQuery(window).scroll(function () {
    var $anchors = $('.anchors');
    $anchors.each(function (i, el) {
      var top = $(el).offset().top - 120;
      var bottom = top + $(el).next().outerHeight();
      var scroll = $(window).scrollTop();
      var id = $(el).attr('id');

      if (scroll > top && scroll < bottom) {
        $('.scroll-header__menu-list li a.active').removeClass('active');
        $('.header__mobile-menu-content-menu-list a.active').removeClass('active');
        $('a[href="/#' + id + '"]').addClass('active');
      }
    });
  });

  if ($(window).width() >= 1200) {
    var footer_copy_pl = $('.footer__description').offset().left - 60;
    $('.footer__copy').css('padding-left', footer_copy_pl + "px");
  } else if ($(window).width() > 992 && $(window).width() < 1200) {
    var _footer_copy_pl = $('.footer__description').offset().left - 60 + 50;

    $('.footer__copy').css('padding-left', _footer_copy_pl + "px");
  } else if ($(window).width() > 768 && $(window).width() < 992) {
    var _footer_copy_pl2 = $('.footer__description').offset().left - 24 - 25;

    $('.footer__copy').css('padding-left', _footer_copy_pl2 + "px");
  } else if ($(window).width() === 768) {
    var _footer_copy_pl3 = $('.footer__description').offset().left - 60 + 25;

    $('.footer__copy').css('padding-left', _footer_copy_pl3 + "px");
  } else if ($(window).width() < 768) {
    var _footer_copy_pl4 = $('.footer__description').offset().left - 24;

    $('.footer__copy').css('padding-left', _footer_copy_pl4 + "px");
  }

  $(window).resize(function () {
    if ($(window).width() >= 1200) {
      var _footer_copy_pl5 = $('.footer__description').offset().left - 60;

      $('.footer__copy').css('padding-left', _footer_copy_pl5 + "px");
    } else if ($(window).width() > 992 && $(window).width() < 1200) {
      var _footer_copy_pl6 = $('.footer__description').offset().left - 60 + 50;

      $('.footer__copy').css('padding-left', _footer_copy_pl6 + "px");
    } else if ($(window).width() > 768 && $(window).width() < 992) {
      var _footer_copy_pl7 = $('.footer__description').offset().left - 24 - 25;

      $('.footer__copy').css('padding-left', _footer_copy_pl7 + "px");
    } else if ($(window).width() === 768) {
      var _footer_copy_pl8 = $('.footer__description').offset().left - 60 + 25;

      $('.footer__copy').css('padding-left', _footer_copy_pl8 + "px");
    } else if ($(window).width() < 768) {
      var _footer_copy_pl9 = $('.footer__description').offset().left - 24;

      $('.footer__copy').css('padding-left', _footer_copy_pl9 + "px");
    }
  });
});